import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-41">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-42">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2
      }} className="bg-brand-slate border border-white/10 rounded-2xl max-w-lg w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-43">
            <div className="flex items-center justify-between mb-6" data-id="element-44">
              <h2 className="text-lg font-bold text-white" data-id="element-45">{title}</h2>
              <button onClick={onClose} className="text-brand-muted hover:text-white transition-colors p-1" data-id="element-46">
                <XIcon className="w-5 h-5" data-id="element-47" />
              </button>
            </div>
            <div className="text-brand-text/70 text-sm leading-relaxed space-y-4" data-id="element-48">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="py-6 px-4 bg-brand-darker border-t border-white/5 text-center" data-id="element-49">
        <div className="max-w-xl mx-auto flex flex-col items-center gap-3" data-id="element-50">
          <p className="text-brand-muted/40 text-[10px]" data-id="element-51">
            © 2025 Libérate del apego emocional. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-3 text-[11px]" data-id="element-52">
            <button onClick={() => setShowPrivacy(true)} className="text-brand-muted/40 hover:text-brand-muted/70 transition-colors underline underline-offset-2" data-id="element-53">
              Privacy Policy
            </button>
            <span className="text-brand-muted/20" data-id="element-54">·</span>
            <button onClick={() => setShowTerms(true)} className="text-brand-muted/40 hover:text-brand-muted/70 transition-colors underline underline-offset-2" data-id="element-55">
              Terms of Service
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Privacy Policy" data-id="element-56">
        <p data-id="element-57">
          <strong className="text-white" data-id="element-58">1. Información que recopilamos</strong>
          <br data-id="element-59" />
          Recopilamos información personal que usted nos proporciona
          directamente, como su nombre y dirección de correo electrónico al
          realizar una compra.
        </p>
        <p data-id="element-60">
          <strong className="text-white" data-id="element-61">2. Uso de la información</strong>
          <br data-id="element-62" />
          Utilizamos su información para procesar transacciones, enviar el
          contenido adquirido y comunicarnos con usted sobre su compra.
        </p>
        <p data-id="element-63">
          <strong className="text-white" data-id="element-64">3. Protección de datos</strong>
          <br data-id="element-65" />
          Implementamos medidas de seguridad para proteger su información
          personal. No compartimos ni vendemos sus datos a terceros.
        </p>
        <p data-id="element-66">
          <strong className="text-white" data-id="element-67">4. Cookies</strong>
          <br data-id="element-68" />
          Utilizamos cookies para mejorar su experiencia de navegación y
          analizar el tráfico del sitio.
        </p>
        <p data-id="element-69">
          <strong className="text-white" data-id="element-70">5. Sus derechos</strong>
          <br data-id="element-71" />
          Usted tiene derecho a acceder, rectificar o eliminar sus datos
          personales en cualquier momento.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Terms of Service" data-id="element-72">
        <p data-id="element-73">
          <strong className="text-white" data-id="element-74">1. Aceptación de los términos</strong>
          <br data-id="element-75" />
          Al acceder y utilizar este sitio web, usted acepta estar sujeto a
          estos términos y condiciones de servicio.
        </p>
        <p data-id="element-76">
          <strong className="text-white" data-id="element-77">2. Producto digital</strong>
          <br data-id="element-78" />
          Este es un producto digital de contenido educativo. Los resultados
          pueden variar según cada persona y su compromiso con el programa.
        </p>
        <p data-id="element-79">
          <strong className="text-white" data-id="element-80">3. Política de reembolso</strong>
          <br data-id="element-81" />
          Debido a la naturaleza digital del producto, no se ofrecen reembolsos
          una vez que se ha accedido al contenido.
        </p>
        <p data-id="element-82">
          <strong className="text-white" data-id="element-83">4. Propiedad intelectual</strong>
          <br data-id="element-84" />
          Todo el contenido del programa está protegido por derechos de autor.
          Queda prohibida su reproducción o distribución sin autorización.
        </p>
        <p data-id="element-85">
          <strong className="text-white" data-id="element-86">
            5. Limitación de responsabilidad
          </strong>
          <br data-id="element-87" />
          Este programa no sustituye el consejo médico o psicológico
          profesional. Consulte a un profesional si necesita ayuda
          especializada.
        </p>
      </Modal>
    </>;
}